import { useEffect, useState } from "react";

const getCountdown = (end: number) => {
  // date math always confuses me...
  // https://stackoverflow.com/a/7709819

  const now = Date.now();
  const ms = end - now;
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor(
    ((ms % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60)) / (1000 * 60)
  );
  const seconds = Math.round(
    (((ms % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60)) % (1000 * 60)) / 1000
  );

  return [days, hours, minutes, seconds];
};

export const useCountdown = (end: number, short?: boolean) => {
  const [timeLeft, setTimeLeft] = useState("...");

  useEffect(() => {
    const timer = setInterval(() => {
      const [days, hours, minutes, seconds] = getCountdown(end);

      const parts: string[] = [];

      if (days > 0) parts.push(days + (short ? "d" : " days"));
      if (hours > 0) parts.push(hours + (short ? "h" : " hours"));
      if (minutes > 0) parts.push(minutes + (short ? "m" : " minutes"));
      if (seconds > 0) parts.push(seconds + (short ? "s" : " seconds"));

      setTimeLeft(parts.join(" "));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [end, short]);

  return { timeLeft };
};
